import { c as t } from "../../../../index.esm-BeDSGXP5.js";
import { css as r } from "styled-components";
const e = (o) => o.componentColors.forms.input, s = {
  input: {
    base: () => /* @__PURE__ */ r([
      "min-width:auto;width:100%;z-index:1;"
    ]),
    variants: {
      unified: () => /* @__PURE__ */ r([
        "border:none;text-align:center;"
      ])
    }
  },
  wrapperBox: () => /* @__PURE__ */ r([
    "align-items:center;border-radius:4px;border-width:2px;border-style:solid;box-sizing:border-box;max-width:100%;text-align:center;",
    ";"
  ], ({ theme: o, variant: i }) => /* @__PURE__ */ r([
    "",
    ""
  ], t({
    borderColor: e(o).unified.border[i ?? "default"],
    marginTop: "xs",
    color: e(o).text.default,
    backgroundColor: o.colors.global.white
  }))),
  divider: () => /* @__PURE__ */ r([
    "",
    ";"
  ], ({ theme: o }) => /* @__PURE__ */ r([
    "",
    ""
  ], t({
    fontSize: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ],
    color: o.componentColors.forms.input.text.divider
  })))
};
export {
  s as default
};
